/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import LoggedIn from "./pages/LoggedIn/LoggedInPage";
import { Routes, Route } from "react-router-dom";
import TenantListwithFilters from "./components/TenantPage/TenantPagewithFilters";
import UserManagement from "./components/UserManagement/UserManagement";
import CreateTenantPage from "./components/CreateTenant/CreateTenantPage";
import EditTenantPage from "./components/EditTenant/EditTenantPage";
import { FC } from "react";
import LogOut from "./pages/LogOut";
import { OidcSecure } from "@axa-fr/react-oidc";
import TenantUserPage from "./components/TenantUser/TenantUserPage";
import CreateUserPage from "./components/UserManagement/CreateUser";
import EditUser from "./components/UserManagement/EditUser";
import UserInformationPage from "./components/UserManagement/UserInformation";
import CreateHoneywellUser from "./components/HoneywellUser/CreateHoneywellUser";
import HoneywellUserInfo from "./components/HoneywellUser/HoneywellUserInfo";
import EditHoneywellUser from "./components/HoneywellUser/EditHoneywellUser";
import HoneywellUserPage from "./components/HoneywellUser/HoneywellUserPage";
import ErrorPage from "./pages/Error/ErrorPage";

export const AppRoutes: FC<any> = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoggedIn />} />
      <Route
        path="/tenant"
        element={
          <OidcSecure>
            <TenantListwithFilters />
          </OidcSecure>
        }
      />
      <Route
        path="/honeywell/user"
        element={
          <OidcSecure>
            <HoneywellUserPage />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/create"
        element={
          <OidcSecure>
            <CreateTenantPage />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/user/create"
        element={
          <OidcSecure>
            <CreateUserPage />
          </OidcSecure>
        }
      />{" "}
      //TODO: Need to replace with right path
      <Route
        path="/tenant/edit/:id"
        element={
          <OidcSecure>
            <EditTenantPage />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/user"
        element={
          <OidcSecure>
            <TenantUserPage />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/user/edit"
        element={
          <OidcSecure>
            <EditUser />
          </OidcSecure>
        }
      />{" "}
      //TODO: Need to replace with right path
      <Route
        path="/user"
        element={
          <OidcSecure>
            <UserManagement />{" "}
          </OidcSecure>
        }
      />
      <Route
        path="/logout"
        element={
          <OidcSecure>
            <LogOut />
          </OidcSecure>
        }
      />
      <Route
        path="/honeywell/user/create"
        element={
          <OidcSecure>
            <CreateHoneywellUser />
          </OidcSecure>
        }
      />
      <Route
        path="/honeywell/user/info"
        element={
          <OidcSecure>
            <HoneywellUserInfo />
          </OidcSecure>
        }
      />
      <Route
        path="/honeywell/user/edit"
        element={
          <OidcSecure>
            <EditHoneywellUser />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/user/info"
        element={
          <OidcSecure>
            <UserInformationPage />
          </OidcSecure>
        }
      />
      <Route
        path="/error"
        element={
          <OidcSecure>
            <ErrorPage />
          </OidcSecure>
        }
      />
      <Route path="/" element={<LoggedIn />} />
    </Routes>
  );
};
